module.exports = __webpack_public_path__ + "static/media/usersActive.29ec9fab.svg";